const initialState = {
    data: {
        companyCertifications: [{}],
        companyPermission: {},
        majorCustomers: [{}],
        productCategories: [{}],
        productProduceds: [{}],
        topMarkets: [{}, {}, {}],
        insuranceCountries: [{}],
        deletedAuditCerts: [],
    },
    status: "uninitialized",
};

export default initialState;